<template>
  <div class="kt-container pt-3">
    <h3 class="text-center">Try other apps</h3>
    <div class="row">
      <div class="col-12 col-sm mb-3">
        <div class="card card-custom ml-auto" style="max-width: 500px">
          <div class="card-header p-0">
            <img class="w-100" src="../assets/images/sizechart.jpg">
          </div>
          <div class="card-body">
            <h3>Size Chart - Clothes Fit Guide</h3>
            <p>Free plan available</p>
            <h6>Smartest way to show sizing charts & up your conversions game</h6>
            <a class="btn btn-primary" href="https://apps.shopify.com/sizes?ref=fastcheckout" target="_blank">Try
              it for FREE</a>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm mb-3">
        <div class="card card-custom mr-auto" style="max-width: 500px">
          <div class="card-header p-0">
            <img class="w-100" src="../assets/images/shipping.jpg">
          </div>
          <div class="card-body">
            <h3>Estimated Shipping Cost</h3>
            <p>Free plan available</p>
            <h6>Show delivery cost by users ip and your store shipping rates</h6>
            <a class="btn btn-primary" href="https://apps.shopify.com/estimated-shipping-rates?ref=fastcheckout" target="_blank">Try
              it for FREE</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OurApps"
}
</script>

<style scoped>

</style>